import React, { FC } from 'react';
import { boardStyles, containerStyles, enemyBarStyles, playerBarStyles } from '~/styles/pages/onboarding.css';
import GameLeaveTool from '../components/Game/components/GameLeaveTool';
import GamePlayerBar from '../components/Game/components/GamePlayerBar';
import DesktopNavigationBar from '../components/PageLayout/components/DesktopNavigationBar';
import MobileHeader from '../components/PageLayout/components/MobileHeader/MobileHeader';

import {
  desktopContainerStyles,
  desktopMainContainerStyles,
  rightContainerStyles,
  mobileContainerStyles,
  mobileMainContainerStyles,
} from '../components/PageLayout/styles.css';

const OnboardingGameSkeletonPage: FC = () => {
  return (
    <>
      <div className={desktopContainerStyles}>
        <DesktopNavigationBar onItemClick={() => {}} banner={null} />

        <div className={desktopMainContainerStyles}>
          <div className={containerStyles}>
            <GamePlayerBar className={enemyBarStyles} isDesktop />
            <div className={boardStyles}>
              <img
                alt="Chess board in initial position"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOng9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCA4IDgiIHNoYXBlLXJlbmRlcmluZz0iY3Jpc3BFZGdlcyI+CjxnIGlkPSJhIj4KICA8ZyBpZD0iYiI+CiAgICA8ZyBpZD0iYyI+CiAgICAgIDxnIGlkPSJkIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBpZD0iZSIgZmlsbD0iI2Y3ZTBiYiIvPgogICAgICAgIDx1c2UgeD0iMSIgeT0iMSIgaHJlZj0iI2UiIHg6aHJlZj0iI2UiLz4KICAgICAgICA8cmVjdCB5PSIxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBpZD0iZiIgZmlsbD0iI2IxODg2NSIvPgogICAgICAgIDx1c2UgeD0iMSIgeT0iLTEiIGhyZWY9IiNmIiB4OmhyZWY9IiNmIi8+CiAgICAgIDwvZz4KICAgICAgPHVzZSB4PSIyIiBocmVmPSIjZCIgeDpocmVmPSIjZCIvPgogICAgPC9nPgogICAgPHVzZSB4PSI0IiBocmVmPSIjYyIgeDpocmVmPSIjYyIvPgogIDwvZz4KICA8dXNlIHk9IjIiIGhyZWY9IiNiIiB4OmhyZWY9IiNiIi8+CjwvZz4KPHVzZSB5PSI0IiBocmVmPSIjYSIgeDpocmVmPSIjYSIvPgo8L3N2Zz4="
                className={boardStyles}
              />
            </div>
            <GamePlayerBar className={playerBarStyles} isDesktop isPlayer />
          </div>
        </div>

        <div className={rightContainerStyles}></div>
      </div>
      <div className={mobileContainerStyles}>
        <MobileHeader leftSlot={<GameLeaveTool onClick={() => {}} />} />

        <div className={mobileMainContainerStyles}>
          <div className={containerStyles}>
            <GamePlayerBar isDesktop={false} className={enemyBarStyles} />
            <div className={boardStyles}>
              <img
                alt="Chess board in initial position"
                src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOng9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCA4IDgiIHNoYXBlLXJlbmRlcmluZz0iY3Jpc3BFZGdlcyI+CjxnIGlkPSJhIj4KICA8ZyBpZD0iYiI+CiAgICA8ZyBpZD0iYyI+CiAgICAgIDxnIGlkPSJkIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBpZD0iZSIgZmlsbD0iI2Y3ZTBiYiIvPgogICAgICAgIDx1c2UgeD0iMSIgeT0iMSIgaHJlZj0iI2UiIHg6aHJlZj0iI2UiLz4KICAgICAgICA8cmVjdCB5PSIxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBpZD0iZiIgZmlsbD0iI2IxODg2NSIvPgogICAgICAgIDx1c2UgeD0iMSIgeT0iLTEiIGhyZWY9IiNmIiB4OmhyZWY9IiNmIi8+CiAgICAgIDwvZz4KICAgICAgPHVzZSB4PSIyIiBocmVmPSIjZCIgeDpocmVmPSIjZCIvPgogICAgPC9nPgogICAgPHVzZSB4PSI0IiBocmVmPSIjYyIgeDpocmVmPSIjYyIvPgogIDwvZz4KICA8dXNlIHk9IjIiIGhyZWY9IiNiIiB4OmhyZWY9IiNiIi8+CjwvZz4KPHVzZSB5PSI0IiBocmVmPSIjYSIgeDpocmVmPSIjYSIvPgo8L3N2Zz4="
                className={boardStyles}
              />
            </div>
            <GamePlayerBar isDesktop={false} isPlayer className={playerBarStyles} />
          </div>
        </div>
      </div>
    </>
  );
};

export default OnboardingGameSkeletonPage;
